import { useList } from "@refinedev/core";
import { useSession } from "@/hooks/useSession";

export interface UserRoleData {
  id: string;
  name: string;
  description: string;
  level: string;
  organization_id?: string | null;
  accesses: Record<string, string[]>;
}

export interface UserRoleOption {
  label: string;
  value: string;
}
export const useUserRoles = () => {
  const { currentOrganization } = useSession();

  const { data, isLoading, error } = useList<UserRoleData>({
    resource: `api/organization/${currentOrganization?.id}/user-roles`,
    queryOptions: {
      staleTime: 1000 * 60 * 30,
      enabled: !!currentOrganization?.id,
    },
  });

  const roleOptions: UserRoleOption[] =
    data?.data?.map((role) => ({
      label: role.name,
      value: role.id,
    })) || [];

  const organizationRoles =
    data?.data?.filter(
      (role) =>
        (role.name.includes("Organization") ||
          ["Admin", "Support"].includes(role.name)) &&
        !["Company Admin", "Partner"].includes(role.name)
    ) || [];

  const workspaceRoles =
    data?.data?.filter(
      (role) =>
        (role.name.includes("Organization") ||
          role.name.includes("Workspace") ||
          role.name === "Admin") &&
        !["Company Admin"].includes(role.name)
    ) || [];

  const organizationRoleOptions: UserRoleOption[] = organizationRoles.map(
    (role) => ({
      label: role.name,
      value: role.id,
    })
  );

  const workspaceRoleOptions: UserRoleOption[] = workspaceRoles.map((role) => ({
    label: role.name,
    value: role.id,
  }));

  return {
    roles: data?.data || [],
    isLoading,
    error,
    roleOptions,
    organizationRoles,
    workspaceRoles,
    organizationRoleOptions,
    workspaceRoleOptions,
  };
};
